// extracted by mini-css-extract-plugin
export default {"root":"BulkDeleteSbatGroupsModal_root__M484H"};